import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState } from 'react';
import { Resource } from '../../../../common/constants/resource';
import { MIBSection } from '../../../tasks/types/mib';
import { RenderMIBCodesSection } from './MIBCodesSection';
import styles from './MIBDetail.module.scss';
import { RenderMIBIAISection } from './MIBIAISection';
import { RenderMIBResult } from './MIBResultSection';

export const RenderMIBSection = (
  section: MIBSection,
  index: number,
  keyPrefix: string = '',
) => {
  return (
    <MIBResponseCard
      key={`${keyPrefix}-${index}`}
      section={section}
      index={index}
    />
  );
};

const MIBResponseCard = ({
  section,
  index,
}: {
  section: MIBSection;
  index: number;
}) => {
  const [open, setOpen] = useState(true);
  const hasCodes = !!(section.codes && section.codes.length);
  const hasIAI = !!(section.iai && section.iai.length);

  return (
    <div className={styles.ResponseCard}>
      <button
        type="button"
        className={styles.ResponseHeader}
        onClick={() => setOpen(prev => !prev)}
        aria-expanded={open}
      >
        <div className={styles.ResponseHeaderLeft}>
          <span className={styles.ResponseNum}>
            {`${Resource.MIB_SECTION_SUBTITLE_PREFIX} ${index}`}
          </span>
        </div>
        <ExpandMoreIcon
          className={`${styles.Chevron} ${open ? styles.ChevronOpen : ''}`}
          fontSize="small"
        />
      </button>
      {open && (
        <>
          {RenderMIBResult(section.detail)}
          {(hasCodes || hasIAI) && (
            <div className={styles.ResponseData}>
              {hasCodes && RenderMIBCodesSection(section.codes)}
              {hasIAI && RenderMIBIAISection(section.iai)}
            </div>
          )}
        </>
      )}
    </div>
  );
};
